// extracted by mini-css-extract-plugin
export default {"body":"LoginForm_body__s0GWI","btn":"LoginForm_btn__Qve9k"};